import { render, staticRenderFns } from "./CalificacionesHSE.vue?vue&type=template&id=8b478b0a"
import script from "./CalificacionesHSE.vue?vue&type=script&lang=js"
export * from "./CalificacionesHSE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports